export default "__VITE_ASSET__Dk40884h__"